import { axiosInstance as axios } from "services";

export const fetchWebhookHistory = async (companyId, limit = 50, offset = 0) => {
  const { data } = await axios.get(`/admin/subscription/company/${companyId}/webhook-history`, {
    params: { limit, offset }
  });
  if (!data.success) throw new Error(data.error?.message || "Failed to fetch webhook history");
  return data;
};
